import { AuthSdkError } from './auth-sdk-error';

/**
 * Thrown when an assertion fails.
 */
class AssertionError extends Error {
  constructor(message: string) {
    super(message);
  }
}

/**
 * Asserts that the given condition is truthy.
 * Accepts an optional message to throw if assertion fails
 * @param condition
 * @param message
 * @throws { AssertionError } - Assertion failed
 */
export function assert(condition: boolean, message?: string): asserts condition {
  if (!condition) {
    throw new AssertionError(message ?? 'Assertion failed');
  }
}

/**
 * Exhaustive match for Typescript Switch statements. Calling this as the `default` case for
 * a switch statement will ensure that all cases have been matched at _compile_ time.
 * @param input
 * @param error
 * @throws { AuthSdkError } - Exhaustive match failed
 */
export function exhaustiveMatch(input: never, error = new AuthSdkError(`Exhaustive match failed: ${input}`)): never {
  throw error;
}
